import Vue from "vue";

Vue.filter('spacedNumber', function (value) {
  if (value == null) return value
  const parts = value.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
})

Vue.filter('spacedAndRoundNumber', function (value) {
  if (value == null) return value
  const [intPart, decPart] = value.toFixed(2).split('.');
  return intPart.length > 3
      ? `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}${decPart === '00' ? '' : '.' + decPart}`
      : value.toFixed(2);
})
